import { idb } from 'boot/indexed-db'
import { FetchMeta } from 'src/models/dexie'
import {
  CanceledApiError,
  NetworkApiError,
  TimeoutApiError,
} from 'src/models/error/errors'
import { HttpCode } from 'src/models/api/enums/HttpErrorCode'

export function removeFetchMeta(key: FetchMeta['key']) {
  return idb.fetchMeta.delete(key)
}
export function addFetchMeta(key: FetchMeta['key']) {
  return idb.fetchMeta.put({
    key: key,
    fetchedAt: new Date().toISOString(),
  })
}

export async function getFetchMeta(key: FetchMeta['key']) {
  return idb.fetchMeta.get(key)
}
export function isOfflineRelatedError(err: unknown) {
  if (err instanceof NetworkApiError || err instanceof TimeoutApiError) {
    if (
      err?.code === HttpCode.ERR_NETWORK ||
      err?.code === HttpCode.ECONNABORTED
    ) {
      return true
    }
  }
  return false
}

export function isCanceledError(err: unknown) {
  if (err instanceof CanceledApiError) {
    if (err?.code === HttpCode.ERR_CANCELED) {
      return true
    }
  }
  return false
}
